// The app's store listings, shared by the footer badges, the FAQ answers,
// `/download` and the app-only page.
export const IOS_APP_URL =
  "https://apps.apple.com/fr/app/shorts-reel-short-drama/id6498894314";
export const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.luni.android.shorts.app";
